<template>
    <div class="title-block">
        <div class="title-block__left">
            <div class="title-block__title">Типы устройств</div>
            <a :href="route_create_page" class="title-block__btn btn-add btn-primary btn">Добавить</a>
        </div>
    </div>

    <table-element :actions="actions" :thead="thead" :tbody="tbody"></table-element>
    <pagination-element :count="count" :current_page="page" @pageChange="pageChange"></pagination-element>
</template>

<script>
import ChangePage from "../../../helpers/ChangePage";
import TableElement from "../../../elements/TableElement";
import PaginationElement from "../../../elements/PaginationElement";
import DeviceType from "../../../models/DeviceType";

export default {
    name: "DeviceTypeComponent",
    components: {
        TableElement,
        PaginationElement
    },
    props: {
        route_create_page: String,
        route_list: String,
        route_delete: String,
        route_get: String,
        route_update: String,
        current_page: {
            type: Number,
            default: 1
        }
    },
    data: function () {
        return {
            //Объект для примера. Удалить после интеграции
            example: {
                view: 'Список',
                brand: 0,
                store: 0,
                address: 0,
                code: 0,
                region: 0,
                city: 0,
                booking: 0,
                moderation: 0,
                sort: 'По дате создания'
            },
            device_type: new DeviceType({
                route_list: this.route_list,
                route_delete: this.route_delete
            }),
            search: '',
            actions: [],
            thead: [
                'Название',
                'Стоимость в месяц (руб.)'
            ],
            tbody: [],
            count: 1,
            limit: 10,
            page: 1,
        }
    },
    methods: {
        loadTable: async function () {
            let response = await this.device_type.loadTable(this.page, this.limit, this.search);
            this.tbody = response.tbody;
            this.count = response.pages;
            if (this.page > 1 && this.tbody.length === 0) {
                this.page = 1;
                ChangePage(this.page, false);
                await this.loadTable();
            }
        },
        pageChange: function (newPage) {
            this.page = newPage;
            this.loadTable();
        }
    },
    mounted() {
        this.loadTable();
    }
}
</script>

<style scoped>

</style>
